import React from "react";
import { useParams } from "react-router-dom";
import { Col, Image, Row } from "antd";

import useMapData from "../../utils/useMapData";
import { VerticalText } from "../../StyledCmp";

const Location = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  return (
    <Row ref={ref} className="location_wrapper">
      <Col lg={15}>
        <h1>Map View</h1>
        <iframe
          title="real-estate"
          src={resultList?.locationLatLongUrl}
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Col>
      <Col lg={5}>
        <h1>Location Map</h1>
        <Image
          src={resultList?.locationMapUrl}
          onContextMenu={e => e.preventDefault()}
          preview={{
            src: resultList?.locationMapUrl,
            title: "Location Map",
            maskStyle: {
              background: "rgba(17, 19, 23, 0.9)",
            },
          }}
          style={{ borderRadius: "12px" }}
        />
      </Col>
      <Col lg={1}>
        <div className="vertical_text">
          <VerticalText>Location</VerticalText>
        </div>
      </Col>
    </Row>
  );
});

export default Location;
